import styled from 'styled-components';

export const ComponentCard = styled.div`
	background-color: ${({ theme }) => theme.gray[0]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 12px;
	padding: 24px;
	transition: all 0.2s ease-in-out;
	display: flex;
	flex-direction: column;
	gap: 20px;
	position: relative;
	overflow: hidden;

	&:hover {
		border-color: ${({ theme }) => theme.gray[400]};
	}
`;

export const CardPreviewArea = styled.div`
	height: 160px;
	background: ${({ theme }) => theme.white};
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	position: relative;
`;

export const CardName = styled.div`
	font-size: 18px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const ComponentGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
	gap: 24px;
	width: 100%;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

export const ComponentList = styled.div`
	display: grid;
	grid-template-columns: minmax(0, 1.5fr) minmax(0, 1.5fr) minmax(0, 1fr) auto auto;
`;

export const ComponentRow = styled.div`
	display: grid;
	grid-template-columns: subgrid;
	grid-column: 1 / -1;
	align-items: center;
	gap: 16px;
	padding: 10px 8px;
	border-bottom: 1px solid ${({ theme }) => theme.gray[200]};
	transition: background-color 0.15s ease;

	&:hover {
		background-color: ${({ theme }) => theme.gray[100]};
	}

	&:last-child {
		border-bottom: none;
	}
`;

export const RowName = styled.div`
	font-size: 14px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[1000]};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const RowTagName = styled.div`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
	font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
		'Courier New', monospace;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const RowCategory = styled.div`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
	text-transform: capitalize;
`;

export const RowProps = styled.div`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[400]};
	white-space: nowrap;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const RowDeps = styled.div`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[400]};
	display: flex;
	align-items: center;
	gap: 4px;
	white-space: nowrap;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const BrokenBadge = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 10px;
	height: 16px;
	padding: 0 4px;
	border-radius: 8px;
	font-size: 10px;
	font-weight: 600;
	background-color: ${({ theme }) => theme.red[500]};
	color: ${({ theme }) => theme.gray[0]};
`;
